import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export interface UpdateAdviceMaintenancePayload {
	adviceId: string;
	name: string;
}

export function useUpdateAdviceMaintenance() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation<void, Error, UpdateAdviceMaintenancePayload>({
		mutationFn: async ({ adviceId, name }) => {
			try {
				await api.put(
					`/advices/fertilization-plan/update/${adviceId}`,
					{ name },
					{ params: { forBinding } }
				);
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar a recomendação de manutenção');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['maintenance'] });
		},
	});
}
